import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { Backend } from "../services/Backend";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { SuccessToast } from "../utils/utils";

export default function EditPermissionItem(props) {
    const [permission, setPermission] = useState(null);

    useEffect(() => {
        setPermission(props.permission);
    },[]);

    const onSubscriptionChange = (newSubcription) => {
        Backend.post(`subscription/${newSubcription}/permission/${permission.id}`);
        setPermission({...props.permission, subscriptionId: newSubcription});
        SuccessToast("Permission modified");
    }

    if(permission === null)
        return;

    return <div className="flex items-center justify-between">
        <span>{permission.description}</span>
        <FormControl sx={{ width: "150px"}} margin="normal">
            <InputLabel>Subscription</InputLabel>
            <Select
                label="Subscription"
                size="small"
                margin="normal"
                value={permission.subscriptionId}
                onChange={(e) => onSubscriptionChange(e.target.value)}
            >
                <MenuItem value="1">Free</MenuItem>
                <MenuItem value="2">Basic</MenuItem>
                <MenuItem value="3">Premium</MenuItem>
            </Select>
        </FormControl>
    </div>
}